import React from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { display } from "styled-system";
import { Container } from "../grid";
import { FooterStyle } from "./footer.style";

const Footer = () => {
    const { t } = useTranslation("components.global.footer");

    return (
        <FooterStyle fixed={false}>
            <Container css={theme => display({ theme, display: "flex" })}>
                <div>
                    <a href={t("url")} target="_blank" rel="noopener noreferrer">{t("companyName")}</a>
                    <span css={{ marginLeft: 4 }}>&copy; {moment().format("YYYY")}</span>
                </div>
                {/*<div css={{ marginLeft: "auto" }}>*/}
                {/*    <span css={{ marginRight: 4 }}>Powered by</span>*/}
                {/*    <a href="https://coreui.io/react" target="_blank" rel="noopener noreferrer">CoreUI for React</a>*/}
                {/*</div>*/}
            </Container>
        </FooterStyle>
    );
};

export default React.memo(Footer);
